<template>
  <div class="loading-overlay">
    <img
      :class="marginSpacing && 'custom-spacing'"
      :src="spinnerUrl"
      alt="Loading Spinner"
    />
  </div>
</template>
<script>
export default {
  name: "LoadingOverlay",
  props: {
    marginSpacing: Boolean
  },
  data() {
    return {
      spinnerUrl: HH_COMPONENTS_URL + "/spinner.svg"
    };
  },
};
</script>
<style scoped>
.loading-overlay img {
  z-index: 10;
  display: block;
  position: fixed;
  top: 30%;
  left: 50%;
  height: 100px;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
}

@media only screen and (max-width: 768px) {
  .loading-overlay img {
    top: 45%;
  }
}
/* Unlike most browsers, firefox will display alt text while the image is loading instead of only if it failed */
.loading-overlay img:-moz-loading {
  visibility: hidden;
}
.loading-overlay p {
  display: block;
  font-size: 30px;
}
</style>
